import React from "react";
import DiagnosisStepsSidebar from "./components/DiagnosisStepsSidebar";
import useBusinessDiagnosisForm from "./hooks/useBusinessDiagnosisForm";
import StepCompanyRegistry from "./steps/StepCompanyRegistry";
import StepCompanyStructure from "./steps/StepCompanyStructure";
import StepCompanySize from "./steps/StepCompanySize";
import StepHumanCapitalGender from "./steps/StepHumanCapitalGender";
import StepHumanCapitalRoles from "./steps/StepHumanCapitalRoles";
import StepHumanCapital from "./steps/StepHumanCapital";
import StepRepresentations from "./steps/StepRepresentations";
import StepOtherInfo from "./steps/StepOtherInfo";

const STEPS = [
  { labelKey: "businessDiagnosisStep1Title", fallbackLabel: "Anagrafica Azienda" },
  { labelKey: "businessDiagnosisStep2Title", fallbackLabel: "Struttura Aziendale" },
  { labelKey: "businessDiagnosisStep3Title", fallbackLabel: "Dimensione Azienda" },
  { labelKey: "businessDiagnosisStep4Title", fallbackLabel: "Capitale Umano Sesso" },
  { labelKey: "businessDiagnosisStep5Title", fallbackLabel: "Capitale Umano Mansioni" },
  { labelKey: "businessDiagnosisStep6Title", fallbackLabel: "Capitale Umano" },
  { labelKey: "businessDiagnosisStep7Title", fallbackLabel: "Rappresentanze" },
  { labelKey: "businessDiagnosisStep8Title", fallbackLabel: "Altre info" },
];

const STEP_COMPONENTS = [
  StepCompanyRegistry,
  StepCompanyStructure,
  StepCompanySize,
  StepHumanCapitalGender,
  StepHumanCapitalRoles,
  StepHumanCapital,
  StepRepresentations,
  StepOtherInfo,
];

  const StoreSettingsBusinessDiagnosis = () => {
  const {
    formData,
    currentStep,
    completedSteps,
    loading,
    saving,
    handleStepSubmit,
    goToStep,
    markAsCompleted,
  } = useBusinessDiagnosisForm();

  const sectionKeys = [
    "company_registry",
    "company_structure",
    "company_size",
    "human_capital_gender",
    "human_capital_roles",
    "human_capital",
    "representations",
    "other_info",
  ];
  const currentSection = sectionKeys[currentStep - 1];
  const StepComponent = STEP_COMPONENTS[currentStep - 1];

  return (
    <>
      {loading ? (
        <div className="flex align-items-center justify-content-center p-4">
          <i className="pi pi-spin pi-spinner text-4xl text-600" />
        </div>
      ) : (
        <div className="flex flex-wrap gap-4">
          <div
            className="pr-3"
            style={{
              minWidth: "15rem",
              maxWidth: "18rem",
            }}
          >
            <DiagnosisStepsSidebar
              steps={STEPS}
              currentStep={currentStep}
              completedSteps={completedSteps}
              onSelectStep={goToStep}
            />
          </div>
          <div
            className="flex-1"
            style={{
              minWidth: "280px",
              maxWidth: "720px",
            }}
          >
            {StepComponent && currentSection && (
              <StepComponent
                data={formData[currentSection] || {}}
                meta={formData.meta || {}}
                onSubmit={(values) => handleStepSubmit(currentStep, values)}
                onBack={currentStep > 1 ? () => goToStep(currentStep - 1) : undefined}
                onSendDiagnosis={markAsCompleted}
                saving={saving}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default StoreSettingsBusinessDiagnosis;

